import { useConfigurationStore } from '@/Store/storeConfiguration';
import { useStoreData } from '@/Store/storeData';
import { requestJson } from '@/utils/httpRequest';
import { getBase64PDF } from '@/pdf/createPDF';
import { getItemsResult } from '@/lib/getItemsResult';
import { getScreenShot } from '@/lib/takeScreenshot';
import { useUIOnlyStore } from '@/Store/storeUI';
import App from '@/UI/TheApp.vue';
import { generateNewProjectName } from '@/lib/generateNewProjectName';

export function saveProject(as?: 'As') {
    window.parent.postMessage({ configurator: {
            action: 'saveProject' + (as?as:''),
            payLoad: {
                projectId: useConfigurationStore().projectId,
                projectName: (as?generateNewProjectName(useConfigurationStore().projectName):useConfigurationStore().projectName),
                projectData: JSON.stringify(useConfigurationStore().$state),
                accessories: JSON.parse(JSON.stringify(useStoreData().getAccessories)),
                screenShot: getScreenShot(),
            },
        } }, '*');
}


export function saveXml() {
    window.parent.postMessage({ configurator: {
            action: 'saveXml',
            payLoad: {
                projectId: useConfigurationStore().projectId,
                projectName: useConfigurationStore().projectName,
                projectData: JSON.stringify(useConfigurationStore().$state),
                accessories: JSON.parse(JSON.stringify(useStoreData().getAccessories)),
            },
        } }, '*');
}

export function newProject() {
    window.parent.postMessage({ configurator: {
            action: 'newProject',
            payLoad: {
                projectId: useConfigurationStore().projectId,
                projectName: useConfigurationStore().projectName,
                projectData: JSON.stringify(useConfigurationStore().$state),
                accessories: JSON.parse(JSON.stringify(useStoreData().getAccessories)),
            },
        } }, '*');
}

export async function order() {
    const itemIDs = useConfigurationStore().getAllItemIDs;
    const accessoriesIds = useStoreData().categoriesItems;
    const currencySymbol = App.methods?.getCurrencySymbol();
    const externalUser = App.methods?.getExternalUser();

    const counts = { ...accessoriesIds };
    itemIDs.forEach((x: number) => { counts[x] = (counts[x] || 0) + 1; });
    window.parent.postMessage({ configurator: {
            action: 'order',
            payLoad: {
                description: '{id, count}',
                order: counts,
                pdf:await getBase64PDF(getItemsResult(), currencySymbol, externalUser),
                project: {
                    projectName: useConfigurationStore().projectName,
                    projectData: JSON.stringify(useConfigurationStore().$state),
                    accessories: JSON.parse(JSON.stringify(useStoreData().getAccessories)),
                },
                screenShot: getScreenShot(),
            },
        } }, '*');
}
export function sendOnLoadedStatus(progress:number){
    window.parent.postMessage({ configurator: {
            action: 'progress',
            payLoad: {
                progress,
            },
        } }, '*');
}
export function onMessageHandler(message: any) {
    // TODO temp
    // console.log(message);
    if (!message.data || !message.data.configurator) return;
    if (message.data.configurator.action === 'clear') {
        useConfigurationStore().clear();
        useUIOnlyStore().setMode('room');
    }

    if (message.data.configurator.action === 'refetchItems') {
        const { modelsPath } = v3d.AppUtils.getPageParams();
        requestJson(modelsPath ?? '/api/configurator/models/').then((({ data })=>{
            // console.log(data);
            if (!data) {
                return;
            }
            useStoreData().receiveCatalog(data);
        }));
    }

    if (message.data.configurator.action === 'setContacts') {
        const data=message.data.configurator.data;
        if (!data) {
            return;
        }
        window.contacts=data;
    }

    if (message.data.configurator.action === 'getPayload') {
        window.parent.postMessage({ configurator: {
                action: 'data',
                payLoad: {
                    project: {
                        projectName: useConfigurationStore().projectName,
                        projectData: JSON.stringify(useConfigurationStore().$state),
                        accessories: JSON.parse(JSON.stringify(useStoreData().getAccessories)),
                    },
                    screenShot: getScreenShot(),
                },
            } }, '*');
    }
}
